import { useGetNbaAllTimeGreatsLeadersQuery } from "../store/api/nbaApi";

export const useNbaAllTimeGreatsLeaderboard = ({
  stat,
  page = 0,
  pageSize = 25,
} = {}) => {
  const { data, isLoading, isFetching, error } =
    useGetNbaAllTimeGreatsLeadersQuery({
      stat,
      page: page + 1,
      pageSize,
    });

  return {
    data,
    results: data?.results || [],
    totalResults: data?.totalResults || 0,
    isLoading: isLoading || isFetching,
    error,
  };
};
